import React ,{ useState, useEffect } from "react"
import _ from 'lodash'
import { Switch } from '@mantine/core';

import ReactJson from "react-json-view"

const OrderInsuredDetail = ({ form }) => {

    const insured = _.get(form.values, "insured") 

    return (
        <>  
            {/* <ReactJson src={insured} collapsed style={{background: "white"}}/> */}
            {insured &&
            <Switch 
                key={"insured.sameAsClient"}
                name={"insured.sameAsClient"}
                {...form.getInputProps("insured.sameAsClient")}                            
                checked={insured.sameAsClient}            
            />
              }

        </> 
            
    )
}


export default OrderInsuredDetail